import buildUrl from './buildUrl'
import download from './downloadFile'

export default function downloadTemplateFile(params) {
    // download(buildUrl('/templeteConfig/getTemplete'), params, '毕业名单模板.xlsx')
    download(buildUrl('/templeteConfig/getTemplete'), params, '毕业名单模板.xlsx')
    // window.location.href = buildUrl('/templeteConfig/getTemplete?')+params2link(params)
}

// function params2link(params) {
//     let link = ''
//     for (let key in params) {
//         link += `${key}=${params[key]}&`
//     }
//     return link
// }